export default __webpack_public_path__ + "7370de7d4f50297f124d3ab79b20a2e9.svg";